import { getHotelRanks } from './getHotelRanks';
import { getHotelSpecialOffers } from './getHotelSpecialOffers';
import { getHotelsOrPagesFromIds } from './getHotelsOrPagesFromIds';
import { getMainBlockHotels } from './getMainBlockHotels';
import getSpecialOffersForHotels from './getSpecialOfferForHotel';

const getPillarResults = (
	allHotels,
	specialOffers,
	allFilteredHotels,
	mainBlockHotelResults,
	specialOfferHotelResults
) => {
	const { goldOffers, silverOffers, internationalOffers } =
		getSpecialOffersForHotels(allHotels, specialOffers);

	const filteredHotelResults = getHotelsOrPagesFromIds(
		allHotels,
		allFilteredHotels
	);

	// -> PHEW! 😅 We're getting there!

	// Sort hotels into ranks
	let hotelResults = getHotelRanks(filteredHotelResults);

	// -> SPECIAL OFFERS
	// Then
	specialOfferHotelResults = getHotelSpecialOffers(
		hotelResults,
		goldOffers,
		silverOffers,
		internationalOffers
	);
	// console.log(
	// 	'🚀 ~ file: getPillarResults.js:23 ~ getPillarResults ~ specialOfferHotelResults:',
	// 	specialOfferHotelResults
	// );

	mainBlockHotelResults = getMainBlockHotels(
		hotelResults,
		specialOfferHotelResults
	);

	return { hotelResults, mainBlockHotelResults, specialOfferHotelResults };
};

export { getPillarResults };
